import { motion } from "framer-motion";
import { CheckCircle2, Trash2 } from "lucide-react";
import { formateazaRON } from "@/lib/settlement";

// O plată de decontare din istoric (marcată ca „plătită").
export function PaymentListItem({ item, numeMembru, formateazaData, onDelete }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      data-testid={`payment-item-${item.id}`}
      className="bg-emerald-50 rounded-2xl border border-emerald-100 p-4 flex items-center gap-3"
    >
      <div className="h-10 w-10 rounded-full bg-emerald-100 flex items-center justify-center shrink-0">
        <CheckCircle2 className="h-5 w-5 text-emerald-600" strokeWidth={2.5} />
      </div>
      <div className="min-w-0 flex-1">
        <p className="font-semibold text-slate-900 truncate">Decontare</p>
        <p className="text-xs text-slate-500 mt-0.5">
          {numeMembru(item.from)} → {numeMembru(item.to)} • {formateazaData(item.createdAt)}
        </p>
      </div>
      <div className="text-right shrink-0">
        <p className="font-heading font-extrabold text-emerald-600">{formateazaRON(item.amount)}</p>
        <button
          data-testid={`delete-payment-btn-${item.id}`}
          aria-label="Anulează plata"
          onClick={() => onDelete(item.id)}
          className="text-slate-400 hover:text-rose-500 transition-colors p-1 mt-1"
        >
          <Trash2 className="h-4 w-4" />
        </button>
      </div>
    </motion.div>
  );
}
